export default function SectionDivider() {
  return (
    <div
      className="relative h-px w-full bg-gradient-to-r from-transparent via-accent-500/45 to-transparent"
      aria-hidden="true"
    />
  );
}